module.exports = global["Tether"] = require("-!E:\\__www\\prestashop-1-7\\themes\\b4n_cascade_custom\\_dev\\node_modules\\babel-loader\\index.js!.\\tether.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?Tether!./~/tether/dist/js/tether.js-exposed
// module id = 28
// module chunks = 0